// extracted by mini-css-extract-plugin
export default {"deliveredModal":"src-pages-Order-AllOrders-OrderDetail-ParcelProcess-ReadyToShip-css-module__deliveredModal--7awUI"};